import { Functions } from "lib/firebase";

export async function cancelAnySubscription({ uid, subscriptionId }) {
    /**
    * subscriptionId => subscription_id
    * uid => customer.id
    */
    try {
        const result = await Functions.httpsCallable('ops-cancelSubscription')({ uid, subscriptionId });
        return result;
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function createSingleItemSubscription(customerId, country) {
    /**
     * id -> subscription_id
     * status => status
     * created => created_at
     * created_from => 'Tidie'
     */
    return await Functions.httpsCallable('stripeCreateSingleItemSubscription')({
        customerId,
        country,
    });
}

export async function createLateBoxSubscription(customerId, country) {
    /**
     * id -> subscription_id
     * status => status
     * created => created_at
     * created_from => 'Tidie'
     */
    return await Functions.httpsCallable('stripeCreateLateBoxSubscription')({ customerId, country });
}

